import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';

// ===== СТИЛИ =====
// 1. Tailwind CSS (остается руками)
import './index.css';

// 2. АВТОМАТИЧЕСКАЯ загрузка ВСЕХ CSS из всего проекта
//import loadAllStyles from './utils/simpleStyleLoader';
// или для продвинутой версии:
import loadAllStyles from './utils/smartStyleLoader';

import theme from './styles/theme';
import { ThemeProvider } from '@mui/material';

import { BrowserRouter } from 'react-router-dom';

// Контексты
import { AnalysisProvider } from './contexts/AnalysisContext';
import { ChannelAnalysisProvider } from './contexts/ChannelAnalysisContext';
import { ChannelDiscoveryProvider } from './contexts/ChannelDiscoveryContext';
import { VideoDiscoveryProvider } from './contexts/VideoDiscoveryContext';
import { ResearchProvider } from './contexts/ResearchContext';
import { AuthProvider } from './contexts/AuthContext';

// Запускаем автозагрузку всех стилей (асинхронно)
loadAllStyles();

// ===== КОМПОНЕНТЫ И ПРОВАЙДЕРЫ =====
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
import { GoogleOAuthProvider } from '@react-oauth/google';
import config from './config';
import { LanguageProvider } from './contexts/LanguageContext';
import Loader from './components/common/Loader';

const supportedLanguages = ['ru', 'en', 'es', 'de', 'fr'];

const Root = () => {
  const [ready, setReady] = useState(i18n.isInitialized);

  useEffect(() => {
    const setupLanguage = () => {
      const saved = localStorage.getItem('appLanguage');
      const browserLang = navigator.language.split('-')[0];
      const fallbackLang = supportedLanguages.includes(browserLang) ? browserLang : 'ru';
      const langToUse = saved || fallbackLang;

      i18n.changeLanguage(langToUse);
      localStorage.setItem('appLanguage', langToUse);
      document.documentElement.lang = langToUse;
    };

    if (!i18n.isInitialized) {
      i18n.on('initialized', () => {
        setupLanguage();
        setReady(true);
      });
    } else {
      setupLanguage();
      setReady(true);
    }
  }, []);

  if (!ready) return <Loader size="lg" />;

  return (
    <I18nextProvider i18n={i18n}>
      <LanguageProvider>
        <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID}>
          <BrowserRouter>
            <AuthProvider>
              <ThemeProvider theme={theme}>
                <AnalysisProvider>
                  <ChannelAnalysisProvider>
                    <ChannelDiscoveryProvider>
                      <VideoDiscoveryProvider>
                        <ResearchProvider>
                          <App />
                        </ResearchProvider>
                      </VideoDiscoveryProvider>
                    </ChannelDiscoveryProvider>
                  </ChannelAnalysisProvider>
                </AnalysisProvider>
              </ThemeProvider>
            </AuthProvider>
          </BrowserRouter>
        </GoogleOAuthProvider>
      </LanguageProvider>
    </I18nextProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);